import { OperationalEquipmentStore } from '@operations/stores/OperationalEquipmentStore'
import { computed, makeObservable } from 'mobx'

export class OperationalEquipmentUIStore {
  constructor(private readonly operationalEquipmentStore: OperationalEquipmentStore) {
    makeObservable(this, {
      items: computed,
    })
  }

  public get items() {
    return this.operationalEquipmentStore.items
  }
}
